/** Display copy for purchase dialogs. Server catalogs remain the price source for card pay. */

export const RECHARGE_SKU = 'cloud_units_6m'
export const RECHARGE_UNITS = 6_000_000

export type PurchaseCurrency = 'eur' | 'usd'

/**
 * Account currency will come from the subscription later (EUR or USD only).
 * Until that field is available, every checkout uses euro.
 */
export const ACCOUNT_CURRENCY: PurchaseCurrency = 'eur'

export const RECHARGE_PACK_PRICE: Record<PurchaseCurrency, {amount: number; label: string}> = {
  eur: {amount: 200, label: '€200'},
  usd: {amount: 250, label: '$250'},
}

export const MAX_PACK_QUANTITY = 20
export const MAX_EXTRA_SEATS = 5
export const RENEW_YEARS = [1, 2, 3] as const
export type RenewYears = (typeof RENEW_YEARS)[number]

/** Catalog modules a subscription may license. Order is display order. */
const CATALOG_MODULES = [
  'GENOME_CHARACTERIZATION',
  'FUNCTIONAL_GENOMICS',
  'TRANSCRIPTOMICS',
  'METAGENOMICS',
  'GENETIC_VARIATION',
  'ENGINE',
] as const

export type CatalogModule = (typeof CATALOG_MODULES)[number]

const MODULE_LABELS: Record<CatalogModule, string> = {
  GENOME_CHARACTERIZATION: 'Genome Characterization',
  FUNCTIONAL_GENOMICS: 'Functional Genomics',
  TRANSCRIPTOMICS: 'Transcriptomics',
  METAGENOMICS: 'Metagenomics',
  GENETIC_VARIATION: 'Genetic Variation',
  ENGINE: 'Engine (OmicsAI Agent & CLI)',
}

export const moduleLabel = (moduleId: string): string =>
  MODULE_LABELS[moduleId as CatalogModule] ?? moduleId.replace(/_/g, ' ')

/** Modules from the catalog that the subscription does not already have. */
export const missingCatalogModules = (owned: string[] | null | undefined): CatalogModule[] => {
  const ownedSet = new Set((owned ?? []).map((m) => m.toUpperCase()))
  return CATALOG_MODULES.filter((m) => !ownedSet.has(m))
}
